export const removeNullFields = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(item => removeNullFields(item)).filter(item => item !== null);
  }
  
  if (obj && typeof obj === 'object') {
    const cleanObj: any = {};
    
    Object.entries(obj).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          const cleaned = removeNullFields(value);
          if (Object.keys(cleaned).length > 0) {
            cleanObj[key] = cleaned;
          }
        } else {
          cleanObj[key] = value;
        }
      }
    });
    
    return cleanObj;
  }
  
  return obj;
};